import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        "w-full h-10 px-3 rounded-md text-base bg-canvas",
        "border border-border-default placeholder:text-fg-subtle",
        "focus-visible:shadow-focus",
        invalid && "border-danger",
        className,
      )}
      {...rest}
    />
  );
});

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean }
>(function Textarea({ className, invalid, ...rest }, ref) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        "w-full px-3 py-2 rounded-md text-md bg-canvas resize-none",
        "border border-border-default placeholder:text-fg-subtle",
        "focus-visible:shadow-focus leading-6",
        invalid && "border-danger",
        className,
      )}
      {...rest}
    />
  );
});
